// Source-guided atlas redraws; generated by valkenhall-assets-lab/signs/export-atlas.mjs.
// Normalized hand-placed landmarks [x, y, brightness]; links follow the pose and props.
export const CLASS_SIGNS = {
  "wildheart": {
    "image": "/mastery/signs/wildheart-atlas.webp",
    "width": 1028,
    "height": 1500,
    "stars": [
      [
        0.147,
        0.229,
        0.95
      ],
      [
        0.178,
        0.407,
        0.75
      ],
      [
        0.289,
        0.94,
        0.65
      ],
      [
        0.503,
        0.043,
        1
      ],
      [
        0.369,
        0.2,
        0.55
      ],
      [
        0.756,
        0.391,
        0.85
      ],
      [
        0.784,
        0.204,
        0.95
      ],
      [
        0.499,
        0.67,
        0.5
      ],
      [
        0.375,
        0.956,
        0.85
      ],
      [
        0.7,
        0.945,
        0.8
      ],
      [
        0.316,
        0.536,
        0.5
      ]
    ],
    "links": [
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        3,
        4
      ],
      [
        4,
        1
      ],
      [
        4,
        5
      ],
      [
        5,
        6
      ],
      [
        4,
        7
      ],
      [
        7,
        8
      ],
      [
        7,
        9
      ]
    ]
  },
  "alchemist": {
    "image": "/mastery/signs/alchemist-atlas.webp",
    "width": 1200,
    "height": 1000,
    "stars": [
      [
        0.418,
        0.107,
        0.9
      ],
      [
        0.31,
        0.258,
        0.65
      ],
      [
        0.208,
        0.568,
        0.55
      ],
      [
        0.471,
        0.458,
        0.85
      ],
      [
        0.567,
        0.502,
        0.75
      ],
      [
        0.792,
        0.524,
        1
      ],
      [
        0.817,
        0.365,
        0.7
      ],
      [
        0.586,
        0.844,
        0.6
      ],
      [
        0.491,
        0.877,
        0.7
      ],
      [
        0.288,
        0.645,
        0.45
      ],
      [
        0.87,
        0.596,
        0.5
      ]
    ],
    "links": [
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        3,
        4
      ],
      [
        4,
        5
      ],
      [
        5,
        6
      ],
      [
        2,
        9
      ],
      [
        9,
        8
      ],
      [
        8,
        7
      ]
    ]
  },
  "battlemage": {
    "image": "/mastery/signs/battlemage-atlas.webp",
    "width": 1158,
    "height": 1358,
    "stars": [
      [
        0.287,
        0.016,
        1
      ],
      [
        0.325,
        0.333,
        0.8
      ],
      [
        0.382,
        0.131,
        0.85
      ],
      [
        0.579,
        0.133,
        0.9
      ],
      [
        0.474,
        0.258,
        0.65
      ],
      [
        0.558,
        0.361,
        0.65
      ],
      [
        0.731,
        0.528,
        0.85
      ],
      [
        0.756,
        0.407,
        0.65
      ],
      [
        0.187,
        0.594,
        0.75
      ],
      [
        0.858,
        0.598,
        0.75
      ],
      [
        0.321,
        0.9,
        0.6
      ],
      [
        0.675,
        0.925,
        0.6
      ],
      [
        0.559,
        0.585,
        0.5
      ]
    ],
    "links": [
      [
        0,
        1
      ],
      [
        2,
        4
      ],
      [
        3,
        4
      ],
      [
        1,
        4
      ],
      [
        4,
        5
      ],
      [
        5,
        6
      ],
      [
        6,
        7
      ],
      [
        1,
        8
      ],
      [
        6,
        9
      ],
      [
        1,
        10
      ],
      [
        6,
        11
      ],
      [
        4,
        12
      ]
    ]
  },
  "oracle": {
    "image": "/mastery/signs/oracle-atlas.webp",
    "width": 1086,
    "height": 1448,
    "stars": [
      [
        0.598,
        0.04,
        0.9
      ],
      [
        0.747,
        0.144,
        0.65
      ],
      [
        0.476,
        0.253,
        0.6
      ],
      [
        0.23,
        0.305,
        0.7
      ],
      [
        0.784,
        0.399,
        0.75
      ],
      [
        0.485,
        0.493,
        1
      ],
      [
        0.079,
        0.543,
        0.5
      ],
      [
        0.346,
        0.737,
        0.95
      ],
      [
        0.065,
        0.774,
        0.65
      ],
      [
        0.865,
        0.736,
        0.5
      ],
      [
        0.236,
        0.949,
        0.55
      ],
      [
        0.63,
        0.958,
        0.65
      ]
    ],
    "links": [
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        4
      ],
      [
        3,
        5
      ],
      [
        4,
        5
      ],
      [
        5,
        7
      ],
      [
        6,
        7
      ],
      [
        7,
        8
      ],
      [
        7,
        10
      ],
      [
        7,
        11
      ]
    ]
  },
  "mimic": {
    "image": "/mastery/signs/mimic-atlas.webp",
    "width": 1200,
    "height": 1236,
    "stars": [
      [
        0.459,
        0.03,
        1
      ],
      [
        0.423,
        0.149,
        0.65
      ],
      [
        0.514,
        0.192,
        0.6
      ],
      [
        0.375,
        0.268,
        0.85
      ],
      [
        0.471,
        0.337,
        0.55
      ],
      [
        0.803,
        0.323,
        0.9
      ],
      [
        0.92,
        0.387,
        0.65
      ],
      [
        0.087,
        0.58,
        0.85
      ],
      [
        0.437,
        0.581,
        0.6
      ],
      [
        0.663,
        0.659,
        0.55
      ],
      [
        0.519,
        0.731,
        0.65
      ],
      [
        0.596,
        0.915,
        0.75
      ],
      [
        0.367,
        0.971,
        0.9
      ]
    ],
    "links": [
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        3,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        5
      ],
      [
        5,
        6
      ],
      [
        3,
        7
      ],
      [
        4,
        8
      ],
      [
        8,
        9
      ],
      [
        8,
        10
      ],
      [
        10,
        11
      ],
      [
        10,
        12
      ]
    ]
  }
};
